export default "__VITE_ASSET__XWbnFfXk__"